import script from "./MAtividadesComOcorrencia.vue?vue&type=script&setup=true&lang=ts"
export * from "./MAtividadesComOcorrencia.vue?vue&type=script&setup=true&lang=ts"

import "./MAtividadesComOcorrencia.vue?vue&type=style&index=0&id=1d09c52c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d09c52c"]])

export default __exports__